<template>
  <main-layout :selectedMenu="'home'">
    <div class="container">
      <div class="message-top">
        <div
          v-for="(item, index) in tab"
          :key="index"
          :class="{ choose: index === contentIndex }"
          @click="changeIndex(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="message-body">
        <div
          v-if="pageList.length > 0"
          class="message-content"
          v-for="(item, index) in pageList"
          :key="index"
        >
          <router-link
            type="div"
            :to="'/peopleCenter/' + item.otherUserId"
            class="name-time"
            v-if="item.otherUserId != null && item.otherUserId != 0"
          >
            <img
              :src="
                item.otherUserAvatar
                  | imageUrl('/static/profile_img_default.png', 40, 40)
              "
            />
          </router-link>
          <div v-else class="name-time">
            <img src="/static/systemImg.png" />
          </div>
          <div class="right" @click="goToDetail($event, item)">
            <div class="name-time">
              {{ item.title ? item.title : item.otherUserNickname }}
              <span>{{ item.time }}</span>
            </div>
            <!--class="hoverlink"-->
            <a :class="{ hoverlink: item.linkUrl != '' }">
              <div class="content" v-html="item.content"></div>
            </a>
          </div>
        </div>
        <div v-if="pageList.length <= 0" class="bottom">
          {{ $t("global.暂无其他更多") }}
        </div>
      </div>
      <pages
        :page-size="pagerParam.pageSize"
        :page-count="pagerParam.pageCount"
        :current-page.sync="pagerParam.currentPage"
        :total="pagerParam.total"
        @current-page-changed="OnCurrentPageChanged"
      ></pages>
    </div>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "../components/service.vue";
import pages from "../components/pages.vue";

export default {
  name: "messageCenter",
  metaInfo() {
    return {
      title: this.$t("global.消息中心") + " | MANA",
    };
  },
  data() {
    return {
      contentIndex: 0,
      tab: [
        this.$t("global.全部通知"),
        this.$t("global.点赞"),
        this.$t("global.评论"),
        this.$t("global.关注"),
        this.$t("global.活动"),
        this.$t("global.系统"),
      ],
      pagerParam: {
        pageSize: 10,
        pageCount: 1,
        currentPage: 1,
        total: 1,
      },
      pageList: [],
    };
  },
  components: {
    MainLayout,
    service,
    pages,
  },
  created() {
    this.pageListF();
  },

  methods: {
    changeIndex(index) {
      this.contentIndex = index;
      this.pageListF();
    },
    pageListF() {
      let params = {
        pageIndex: this.pagerParam.currentPage,
        pageSize: this.pagerParam.pageSize,
      };
      if (this.contentIndex > 0) {
        params.type = this.contentIndex;
      }
      this.$http
        .get("/api/u/message/list", {
          params: params,
        })
        .then((response) => {
          let data = response.data;
          this.pageList = data.list;

          this.pageList.map(function (item) {
            item.time = new Date(item.createTime).format("yyyy-MM-dd");
          });

          this.pagerParam.pageSize = data.pageSize;
          this.pagerParam.total = data.totalRecord;
          this.pagerParam.pageCount = data.totalPage;
          this.pagerParam.currentPage = data.pageIndex;
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.pageListF();
    },
    goToDetail(e, item) {
      let target = e.target;
      if (item.linkUrl != "") {
        if (item.linkUrl.indexOf("reply") !== -1) {
            window.open("https://m.manamana.net/" + item.linkUrl);
        } else {
          window.open(item.linkUrl);
        }
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.message-body {
  background: #ffffff;
  margin-top: 0.2rem;
  padding: 0 0.6rem;

  .bottom {
    color: #0161ff;
    padding: 0.42rem 0;
    text-align: center;
    font-size: 0.18rem;
  }

  .message-content {
    display: flex;
    padding: 0.37rem 0;
    border-bottom: 1px solid #eeeeee;
    word-wrap: break-word;

    img {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 0.4rem;
    }

    .right {
      margin-left: 0.15rem;
    }

    .name-time {
      color: #333333;
      font-size: 0.18rem;

      span {
        color: #999999;
        font-size: 0.16rem;
      }
    }

    .content {
      color: #777777;
      font-size: 0.16rem;
      margin-top: 0.15rem;
    }
  }
}

.message-top {
  width: 100%;
  height: 1rem;
  background: #ffffff;
  display: flex;

  > div {
    font-size: 0.26rem;
    line-height: 1rem;
    margin-left: 1.36rem;
    color: #707070;
    cursor: pointer;
  }

  .choose {
    color: #333333;
    border-bottom: 2px solid #333333;
  }
}

.container {
  margin: 0.42rem auto;
}

.hoverlink:hover {
  cursor: pointer;
  text-decoration: underline;
}

.hoverlink:hover .content {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/MessageCenter.vue